import * as React from "react";
import Link from "next/link";
import { useOfferModeWithFsecure } from "@nju/data-access-portal-offers/src/utils";
import { Icon, IconName } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import {
  A,
  AProps,
  BlockText,
  Button,
  ButtonProps,
  Heading,
  Panel,
  Separator,
} from "@nju/ui";

export interface IPaymentNotificationProps {
  title: string;
  description?: string;
  iconName?: IconName;
  image?: string;
  redirectUrl?: string;
  callback?: () => void;
  linkVariant?: AProps["variant"];
  buttonVariant?: ButtonProps["variant"];
  textButton?: string;
  changePaymentMethodFromSummary?: boolean;
  userId: string | undefined;
}

export function PaymentNotification({
  title,
  description,
  iconName,
  image,
  redirectUrl,
  buttonVariant,
  linkVariant,
  callback,
  textButton = "ok",
  changePaymentMethodFromSummary = false,
  userId,
}: IPaymentNotificationProps) {
  const mode = useOfferModeWithFsecure();

  return (
    <Panel testId="success-change-payment-method-panel">
      <Heading
        align="center"
        font="ttfirs"
        tone="neutral"
        variant="h2"
        weight="bold"
      >
        {title}
      </Heading>
      {iconName && (
        <>
          <Separator size="s" tone="invisible" />
          <div className="flex justify-center">
            <Icon
              className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
              name={iconName}
            />
          </div>
          <Separator size="s" tone="invisible" />
        </>
      )}
      {image && (
        <>
          <Separator size="s" tone="invisible" />
          <div className="flex justify-center">
            <Icon
              className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
              name="mobile-alt-incircle-succes"
            />
          </div>
          <Separator size="s" tone="invisible" />
        </>
      )}
      {description && (
        <BlockText
          align="center"
          size={{ "@onlyMobile": "s", "@fromTablet": "m" }}
        >
          {description}
        </BlockText>
      )}
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center only-mobile:flex-col">
        {callback && (
          <Button
            onPress={callback}
            size={{ "@onlyMobile": "s" }}
            variant={buttonVariant}
          >
            {textButton}
          </Button>
        )}
        {!callback && (
          <Link
            href={
              redirectUrl
                ? redirectUrl
                : portalRoutes.mojeKonto.platnosci.index.get({
                    ...(changePaymentMethodFromSummary && {
                      zmianaMetodyPlatnosci: "1",
                    }),
                    mode,
                    ...(userId && { userId }),
                  })
            }
            passHref={true}
          >
            <A size={{ "@onlyMobile": "s" }} variant={linkVariant}>
              {textButton}
            </A>
          </Link>
        )}
      </div>
    </Panel>
  );
}
